import type { Search } from 'history';

const getQueryValue = (locationQuery: Search) => (key: string) => {
  if (locationQuery) {
    const queryIdx = locationQuery.indexOf('?');
    if (queryIdx > -1) {
      const queryObject = new URLSearchParams(locationQuery.substring(queryIdx + 1));
      return queryObject.get(key);
    }
  }
};
export default getQueryValue;
